import { DefaultEntity } from '@/types';
import { BaseService } from './base.service';
import APIService from './axios.service';

export interface ThirdPartyOption {
  id: string;
  name: string;
}

class ThirdPartyServiceClass extends BaseService<
  'thirdParty',
  DefaultEntity,
  DefaultEntity
> {
  constructor() {
    super('third-party/internal');
  }

  getThirdPartyOptions = (): Promise<ThirdPartyOption[]> => {
    return APIService.get(this.path);
  };
}

export const thirdPartyService = new ThirdPartyServiceClass();
